import React, { useEffect, useState } from "react";
import "./FullscreenButton.scss";

interface IProps {

}

export function FullscreenButton(props: IProps) {
    const [show, setShow] = useState(false);
    const handleClick = () => {
        try {
            const elem = document.body;
            //@ts-ignore
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
                //@ts-ignore
            } else if (elem.webkitRequestFullscreen) { /* Safari */
                //@ts-ignore
                elem.webkitRequestFullscreen();
                //@ts-ignore
            } else if (elem.msRequestFullscreen) { /* IE11 */
                //@ts-ignore
                elem.msRequestFullscreen();
            }
        } catch (e) {
            //
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'u') {
                setShow((prevState) => !prevState)
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, []);

    if (!show) {
        return <></>
    }

    return (
        <button className={"full-screen-button"} onClick={handleClick}>
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 357 357">
                <g>
                    <path
                        d="M51 229.5H0V357h127.5v-51H51v-76.5zm-51-102h51V51h76.5V0H0v127.5zM306 306h-76.5v51H357V229.5h-51V306zM229.5 0v51H306v76.5h51V0H229.5z"
                        fill="#000000" data-original="#000000" className=""></path>
                </g></svg>
        </button>
    )
}
